module.exports = __webpack_public_path__ + "img/3.ad80f825.svg";